import 'slick-carousel'

$(window).on('load', function() {
  if ($('.js-topVisualSlider').length) {
    const $slider = $('.js-topVisualSlider')

    // 左右の透過の2周目ががたつく対応
    $slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      $slider.find('.slick-slide').each((index, el) => {
        const $this = $(el)
        const slickindex = $this.attr('data-slick-index')
        if (nextSlide == slick.slideCount - 1 && currentSlide == 0) {
          // 現在のスライドが最初のスライドでそこから最後のスライドに戻る場合
          if (slickindex == '-1') {
            // 最後のスライドに対してクラスを付与
            $this.addClass('is-active-next')
          } else {
            // それ以外は削除
            $this.removeClass('is-active-next')
          }
        } else if (nextSlide == 0) {
          // 次のスライドが最初のスライドの場合
          if (slickindex == slick.slideCount) {
            // 最初のスライドに対してクラスを付与
            $this.addClass('is-active-next')
          } else {
            // それ以外は削除
            $this.removeClass('is-active-next')
          }
        } else {
          // それ以外は削除
          $this.removeClass('is-active-next')
        }
      })
    })

    $slider.slick({
      arrows: true,
      autoplay: true,
      adaptiveHeight: true,
      centerMode: true,
      centerPadding: '13%',
      dots: true,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            arrows: false,
            centerMode: false,
            centerPadding: '0'
          }
        }
      ]
    })

    $(document).on('click', '.slick-slide:not(.slick-center)', function() {
      if ($('body').css('min-width') == '1060px') {
        return false
      }
    })
  }
})
$(window).on('resize', function() {
  if ($('.js-topVisualSlider').length) {
    $('.js-topVisualSlider')[0].slick.refresh()
  }
})
